/**
 * Strings da origem do caso aberto pela operação (E177.F1, GUS-253 A1, ADR-0131) — entram em
 * `abertura.origem`. Na abertura não há campo de banco: ele vem da leitura da CCB (o CNPJ do
 * credor), e o escritório requerente é opcional. Na mesa, quando a leitura não identifica o banco, a
 * equipe o escolhe. Valem as regras do `pt-BR.ts`: nenhum termo técnico interno.
 */
export const ptBROrigemDoCaso = {
  titulo: 'Origem do caso',
  banco: 'Banco',
  bancoPelaLeitura:
    'Identificado pela leitura da CCB, pelo CNPJ do credor. Se não for identificado, a equipe o informa na mesa do caso.',
  escolhaOBanco: 'Escolha o banco',
  ajudaDoBanco: 'O banco cliente do caso: ele passa a acompanhar o caso no portal.',
  escritorio: 'Escritório requerente',
  semEscritorio: 'Nenhum (a própria equipe)',
  ajudaDoEscritorio: 'Opcional. Aparece como escritório requerente no exame.',
  nenhumVinculado: 'Nenhum escritório atende este banco.',
  carregando: 'Carregando a lista…',
  erro: 'Não foi possível carregar os bancos e os escritórios. Recarregue a página.',
  nenhumBanco: 'Nenhum banco cadastrado ainda.',
  obrigatorio: 'Escolha o banco do caso.',
  erroInvalida:
    'O banco ou o escritório escolhido não está mais cadastrado assim. Recarregue a página e escolha de novo.',
};
